export default __webpack_public_path__ + "static/media/The Shield of Alkmeenon.825ec3e2.jpg";